<template>
  <component :is="currentComponent" v-bind="{ ...properties, abTesting, originalComponent }" />
</template>
<script>
import Category from '../components/Blog/Category';
import Page from '../components/Page';
import LandingPage from '../components/LandingPage';
import AffiliatePage from '../components/AffiliatePage';
import CoursePage from '../components/CourseSale/CoursePage';
import DiscoverPage from '../components/DiscoverPage';
import AlternativePage from '../components/AlternativePage';
import ABWrapper from '../components/ABWrapper';

import {
  LANDING_PAGES, SELLABLE_COURSES, AFFILIATE_PAGES, DISCOVER_PAGES, AB_TESTING_PAGES, ALTERNATIVE_PAGES_URLS,
} from '../utils/constants';

export default {
  components: {
    Category, Page, LandingPage, AffiliatePage, CoursePage, DiscoverPage, ABWrapper, AlternativePage,
  },
  async asyncData({
    $axios, route, error, store, redirect, $config,
  }) {
    let data = {};
    const url = route.path.replace(/\//g, '').toLowerCase();
    const urlFull = route.fullPath.replace(/\//g, '');
    const ABTesting = AB_TESTING_PAGES.find((p) => p.slug === url) || {};

    const landingPagesUrls = LANDING_PAGES.map((lp) => lp.replace(/\//g, ''));
    const coursePagesUrls = SELLABLE_COURSES.map((lp) => lp.replace(/\//g, ''));
    const affiliatePagesUrls = AFFILIATE_PAGES.map((lp) => lp.replace(/\//g, ''));
    const discoverPagesUrls = DISCOVER_PAGES.map((lp) => lp.replace(/\//g, ''));
    const alternavitePagesUrls = ALTERNATIVE_PAGES_URLS[$config.platform].map((lp) => lp.replace(/\//g, ''));

    // LANDING PAGES
    if (landingPagesUrls.includes(url)) {
      let userInfo = {};
      if (url === 'upgrade-offer' && store.getters['auth/user'].role !== 'admin') {
        if (store.state.auth.user) {
          const registeredAt = new Date(store.state.auth.user.registeredAt);

          if (new Date(registeredAt.setDate(registeredAt.getDate() + 5)) < new Date()) {
            redirect('/you-missed-it/');
          }

          userInfo = store.state.auth.user;
        } else if (route.query.link) {
          userInfo = await $axios.$get(`/user/info?link=${route.query.link}`).catch(() => {});

          if (!userInfo) {
            redirect('/you-missed-it/');
          }
        } else {
          redirect('/you-missed-it/');
        }
      }

      const seo = await $axios.$get(`/pages/${url}?prices=1`).catch(() => error({ statusCode: 404, message: 'Page not found' }));

      data = { currentComponent: 'LandingPage', properties: { seo, userInfo, url } };
    }

    // Course pages
    if (coursePagesUrls.includes(url)) {
      const { coupon = '' } = route.query;

      const course = await $axios.$get(`/courses/landing/${url}${coupon ? `?coupon=${coupon}` : ''}`).catch(() => {});

      if (!course) {
        return error({ statusCode: 404, message: 'Course not found' });
      }

      const seo = await $axios.$get(`/pages/${url}`).catch(() => error({ statusCode: 404, message: 'Page not found' }));

      data = {
        currentComponent: 'CoursePage',
        properties: { seo, courseInfo: course },
      };
    }

    // Affiliate pages
    if (affiliatePagesUrls.includes(url)) {
      if ($config.platform === 'fa') {
        return error({ statusCode: 404, message: 'Page not found' });
      }

      const instructor = await $axios.$get(
        `/team/landing/${url}`,
      ).catch(() => false);

      if (!instructor) {
        return error({ statusCode: 404, message: 'Instructor not found' });
      }

      const [stats, seo] = await Promise.all([
        await $axios.$get('/stats/courses?reduced=1').catch(() => ({})),
        await $axios.$get(`/pages/${url}?prices=1`).catch(() => ({})),
      ]);

      data = {
        currentComponent: 'AffiliatePage',
        properties: {
          seo, instructor, stats, url,
        },
      };
    }

    // Alternative pages
    if (alternavitePagesUrls.includes(url)) {
      const seo = await $axios.$get(`/pages/${url}?prices=1`).catch(() => error({ statusCode: 404, message: 'Page not found' }));

      data = {
        currentComponent: 'AlternativePage',
        properties: { seo },
      };
    }

    // Discover pages
    if (discoverPagesUrls.includes(url)) {
      const seo = await $axios.$get(`/pages/${url}${route.query.resourcesCategory ? `?filter[resourcesCategory]=${route.query.resourcesCategory}` : ''}`);

      data = { currentComponent: 'DiscoverPage', properties: { seo } };
    }

    // Blog category
    if (!data.currentComponent) {
      const categoryResponse = await $axios.$get(`/blog/categories/${urlFull}`, { noError: true }).catch(() => false);
      if (categoryResponse && categoryResponse.parent) {
        return error({ statusCode: 404, message: 'Category not found' });
      }

      if (categoryResponse) {
        const seo = await $axios.$get(`/pages/${urlFull}`).catch(() => error({ statusCode: 404, message: 'Page not found' }));

        if (!seo) {
          return error({ statusCode: 404, message: 'Page not found' });
        }

        data = { currentComponent: 'Category', properties: { info: { ...categoryResponse, ...seo, categoryId: categoryResponse.id } } };
      }
    }

    // Blog article
    if (!data.currentComponent) {
      const pageResponse = await $axios.$get(`/pages/${urlFull}?filter[locked]=0`).catch(() => false);
      if (pageResponse) {
        data = { currentComponent: 'Page', properties: { info: pageResponse } };
      }
    }

    if (data.currentComponent) {
      if (ABTesting.slug) {
        data = {
          ...data,
          currentComponent: 'ABWrapper',
          originalComponent: data.currentComponent,
          abTesting: ABTesting || {},
        };
      }

      return {
        abTesting: {},
        originalComponent: '',
        ...data,
      };
    }

    return error({ statusCode: 404, message: 'Page not found' });
  },
  head() {
    return {
      titleTemplate: 'Page not found%s',
    };
  },
};
</script>
